import StackedBarChartWidget from './StackedBarChartWidget';

export default StackedBarChartWidget; 